import { render, staticRenderFns } from "./ViewDeletedTransaction.vue?vue&type=template&id=25d7ee58&"
import script from "./ViewDeletedTransaction.vue?vue&type=script&lang=js&"
export * from "./ViewDeletedTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports